module.exports = __webpack_public_path__ + "img/sponsorO28.ad03105d.png";